import {Header} from '../util/header';
import {Slider} from '../util/slider';
import {Accordion} from '../util/accordion';
import {Parallax} from '../util/simpleParallax';
import {ScrollToTop} from '../util/scroolToTop';
import {NavigationDesactived} from '../util/navDesactived'
import AOS from 'aos';

export default {
    init() {
        new Header()
        new ScrollToTop()
        new Slider()
        new AOS.init();
        new Accordion('.simple-accordeon_item', '.simple-accordeon_container')
        new Parallax()
        new NavigationDesactived()
    },
    finalize() {
    },
};



// WEBPACK FOOTER //
// ./js/routes/common.js